import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent = ({ onAccept, onDecline }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const hasConsent = localStorage.getItem('userHasAcceptedCookies');
    
    // Если согласие уже было дано - активируем метрику
    if (hasConsent === 'true') {
      activateYandexMetrika();
      setIsVisible(false);
    } 
    // Если пользователь уже отказался - не показываем и не активируем
    else if (hasConsent === 'false') {
      setIsVisible(false);
    } 
    // Если выбор не сделан - показываем уведомление
    else {
      setIsVisible(true);
    }
    
    setIsLoading(false);
  }, []);

  const activateYandexMetrika = () => {
    // Проверяем, загружена ли уже метрика
    if (typeof window.ym === 'function') {
      // Метрика уже загружена, просто инициализируем
      window.ym(99220711, 'init', {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true
      });
      return;
    }

    // Загружаем скрипт метрики
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://mc.yandex.ru/metrika/tag.js';
    
    script.onload = () => {
      // Проверяем, что ym загрузился и является функцией
      if (typeof window.ym === 'function') {
        window.ym(99220711, 'init', {
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          webvisor: true
        });
        
        // Отправляем событие о согласии
        window.ym(99220711, 'reachGoal', 'cookie_consent_accepted');
      } else {
        // Если по какой-то причине ym не загрузился, пробуем еще раз через небольшую задержку
        setTimeout(() => {
          if (typeof window.ym === 'function') {
            window.ym(99220711, 'init', {
              clickmap: true,
              trackLinks: true,
              accurateTrackBounce: true,
              webvisor: true
            });
          } else {
            console.warn('Yandex.Metrika failed to load');
          }
        }, 500);
      }
    };
    
    script.onerror = () => {
      console.error('Failed to load Yandex.Metrika script');
    };
    
    document.head.appendChild(script);
  };

  const handleAccept = () => {
    localStorage.setItem('userHasAcceptedCookies', 'true');
    activateYandexMetrika();
    setIsVisible(false);
    if (onAccept) onAccept();
  };

  const handleDecline = () => {
    localStorage.setItem('userHasAcceptedCookies', 'false');
    setIsVisible(false);
    if (onDecline) onDecline();
  };

  if (isLoading || !isVisible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <span className="cookie-icon">🍪</span>
          <p>
            Мы используем cookies и Яндекс.Метрику для улучшения работы сайта. 
            Нажимая «Принять», вы соглашаетесь с{' '}
            <a href="/policy" className="cookie-policy-link">
              Политикой обработки персональных данных
            </a>
          </p>
        </div>
        <div className="cookie-consent-buttons">
          <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>
            Принять
          </button>
          <button className="cookie-btn cookie-btn-decline" onClick={handleDecline}>
            Отклонить
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;